<template>
  <div class="complex-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form ref="form" :inline="true" size="small" :model="searchForm" label-width="70px" :rules="rules" @submit.native.prevent>
            <el-form-item label="接单日期">
              <el-date-picker
                v-model="searchForm.saleTime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="拆单日期">
              <el-date-picker
                v-model="searchForm.splitTime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <br>
            <el-form-item label="报价日期">
              <el-date-picker
                v-model="searchForm.offerTime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="下单日期">
              <el-date-picker
                v-model="searchForm.downTime"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <br>
            <el-form-item label="经销商" prop="dealer">
              <el-select v-model="searchForm.dealer" clearable multiple placeholder="请选择经销商" filterable style="width:495px;">
                <el-option
                  v-for="item in dealerList"
                  :key="item.dealer_id"
                  :label="item.all_name"
                  :value="item.dealer_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="user.role===3" label="组织">
              <el-select v-model="searchForm.group" style="width: 120px" filterable clearable>
                <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name" :value="item.groupid" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-s-data" type="primary" @click="getData('form')">统计</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <div class="table">
              <el-table
                ref="tableData"
                @sort-change="sortChange"
                v-loading="loading"
                :data="tableData"
                stripe
                show-summary
                style="width: 100%">
                <el-table-column
                  prop="name"
                  label="经销商"
                  width="180">
                </el-table-column>
                <el-table-column
                  prop="orderNum"
                  align="center"
                  label="正单数量">
                </el-table-column>
                <el-table-column
                  prop="addOrderNum"
                  align="center"
                  label="补单数量">
                </el-table-column>
                <el-table-column
                  prop="saleMoney"
                  align="center"
                  label="接单金额（预估）">
                </el-table-column>
                <el-table-column
                  prop="splitMoney"
                  align="center"
                  label="拆单金额（预估）">
                </el-table-column>
                <el-table-column
                  prop="offerMoney"
                  align="center"
                  label="报价金额">
                </el-table-column>
                <el-table-column
                  sortable
                  prop="downMoney"
                  align="center"
                  label="下单金额">
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="tcf-row" style="padding-top: 0;">
      <el-col class="card" :span="24">
        <div class="card-body">
          <div class="card-title">
            统计分析
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="24">
                <GraphicsChart id="height" :option="columnOption"/>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import GraphicsChart from '../../../components/Charts/GraphicsChart'
import { getGroupReport } from '@/api/pub'
import { orderComplexReport, getOrderReportDealer } from '@/api/tj'

export default {
  name: 'ddzhtj',
  components: { GraphicsChart },
  data() {
    return {
      tableData: [],
      loading: false,
      searchForm: {
        group: null,
        dealer: [],
        saleTime: [],
        splitTime: [],
        offerTime: [],
        downTime: []
      },
      rules: {
        dealer: [{ required: true, message: '请选择经销商', trigger: 'change' }]
      },
      dealerList: [],
      groupList: [],
      columnData: [],
      columnOption: {
        title: false,
        exporting: {
          enabled: true
        },
        credits: {
          enabled: false
        }
      }
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getGroupReport()
  },
  methods: {
    clearTable() {
      this.$refs.tableData.clearSort()
    },
    sortChange(column) {
      let tableData = JSON.parse(JSON.stringify(this.tableData))
      if (tableData.length > 1) {
        if (column.order === 'descending') {
          function compare(value1, value2) {
            if (value1.downMoney > value2.downMoney) {
              return -1
            } else if (value1.downMoney < value2.downMoney) {
              return 1
            } else {
              return 0
            }
          }
          tableData.sort(compare)
        }
        if (column.order === 'ascending') {
          function compare(value1, value2) {
            if (value1.downMoney < value2.downMoney) {
              return -1
            } else if (value1.downMoney > value2.downMoney) {
              return 1
            } else {
              return 0
            }
          }
          tableData.sort(compare)
        }
        if (column.order === '' || column.order === null || column.order === undefined) {
          tableData = this.tableData
        }
        const dealerNames = []
        const saleMoney = []
        const splitMoney = []
        const offerMoney = []
        const downMoney = []
        for (const item of tableData) {
          dealerNames.push(item.name)
          saleMoney.push(item.saleMoney)
          splitMoney.push(item.splitMoney)
          offerMoney.push(item.offerMoney)
          downMoney.push(item.downMoney)
        }
        const chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            type: 'column'
          },
          title: false,
          credits: {
            enabled: false
          },
          xAxis: {
            categories: dealerNames,
            crosshair: true
          },
          yAxis: {
            min: 0,
            title: {
              text: '金额'
            }
          },
          tooltip: {
            // head + 每个 point + footer 拼接成完整的 table
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f} 元</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
          },
          plotOptions: {
            column: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.y}'
              }
            }
          },
          series: [{ name: '接单金额', data: saleMoney },
            { name: '拆单金额', data: splitMoney },
            { name: '报价金额', data: offerMoney },
            { name: '下单金额', data: downMoney }]
        }
        this.columnOption = chart
      }
    },
    getData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let saleTimeStart = ''
          let saleTimeEnd = ''
          if (this.searchForm.saleTime !== null && this.searchForm.saleTime.length === 2) {
            saleTimeStart = this.searchForm.saleTime[0]
            saleTimeEnd = this.searchForm.saleTime[1]
          }
          let splitTimeStart = ''
          let splitTimeEnd = ''
          if (this.searchForm.splitTime !== null && this.searchForm.splitTime.length === 2) {
            splitTimeStart = this.searchForm.splitTime[0]
            splitTimeEnd = this.searchForm.splitTime[1]
          }
          let offerTimeStart = ''
          let offerTimeEnd = ''
          if (this.searchForm.offerTime !== null && this.searchForm.offerTime.length === 2) {
            offerTimeStart = this.searchForm.offerTime[0]
            offerTimeEnd = this.searchForm.offerTime[1]
          }
          let downTimeStart = ''
          let downTimeEnd = ''
          if (this.searchForm.downTime !== null && this.searchForm.downTime.length === 2) {
            downTimeStart = this.searchForm.downTime[0]
            downTimeEnd = this.searchForm.downTime[1]
          }
          const data = {
            saleTimeStart: saleTimeStart,
            saleTimeEnd: saleTimeEnd,
            splitTimeEnd: splitTimeEnd,
            splitTimeStart: splitTimeStart,
            offerTimeEnd: offerTimeEnd,
            offerTimeStart: offerTimeStart,
            downTimeEnd: downTimeEnd,
            downTimeStart: downTimeStart,
            ids: this.searchForm.dealer.join(','),
            groupid: this.searchForm.group,
            userid: this.user.dUserid
          }
          this.loading = true
          this.columnData = []
          orderComplexReport(data).then(response => {
            const dealerNames = []
            const arrays = []
            const saleMoney = []
            const splitMoney = []
            const offerMoney = []
            const downMoney = []
            for (const item of response.data) {
              dealerNames.push(item.name)
              saleMoney.push(item.saleMoney)
              splitMoney.push(item.splitMoney)
              offerMoney.push(item.offerMoney)
              downMoney.push(item.downMoney)
            }
            const chart = {
              lang: {
                printChart: '打印图表',
                downloadPNG: '下载JPEG 图片',
                downloadJPEG: '下载JPEG文档',
                downloadPDF: '下载PDF 图片',
                downloadSVG: '下载SVG 矢量图',
                contextButtonTitle: '下载图片'
              },
              chart: {
                type: 'column'
              },
              title: false,
              credits: {
                enabled: false
              },
              xAxis: {
                categories: dealerNames,
                crosshair: true
              },
              yAxis: {
                min: 0,
                title: {
                  text: '金额'
                }
              },
              tooltip: {
                // head + 每个 point + footer 拼接成完整的 table
                headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                  '<td style="padding:0"><b>{point.y:.1f} 元</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true
              },
              plotOptions: {
                column: {
                  borderWidth: 0,
                  dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                  }
                }
              },
              series: [{ name: '接单金额', data: saleMoney },
                { name: '拆单金额', data: splitMoney },
                { name: '报价金额', data: offerMoney },
                { name: '下单金额', data: downMoney }]
            }
            this.columnOption = chart
            this.tableData = response.data
            this.loading = false
            this.clearTable()
          }).catch(() => {
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    getGroupReport() {
      if (this.user.role === 3) {
        // 组织
        getGroupReport().then(response => {
          const arr = []
          for (const item of response.data) {
            if (item.nature === 0) {
              arr.push(item)
            }
          }
          this.groupList = arr
        })
      }
      // 经销商
      getOrderReportDealer({ userid: this.user.dUserid, role: this.user.role, groupid: this.user.dGroupid }).then(response => {
        this.dealerList = response.data
      })
    }
  }
}
</script>

<style scoped>

</style>
